import Page from '../../core/Page'

import Hero from '../../components/hero'
// import Footer from '../../components/footer'
// import CtaMail from '../../components/ctaMail'
// import LinesDetail from '../../components/linesDetail'
// import AnimesUp from '../../components/animesUp'
import Header from '../../components/header'
import lazyload from '../../utils/lazyload'

class SingleProject extends Page {
  askShow (previousPage) {
    return new Promise((resolve, reject) => {
      this.show(() => {
        this.state.shown = true
        resolve()
      }, previousPage)
    })
  } 


  askHide (nextPage) {
    return new Promise((resolve, reject) => {
      this.hide(() => {
        this.state.hidden = true
        this.unmout()
        resolve()
      }, nextPage)
    })
  }

  show (callback, previousPage) {
    this.el.style.opacity = 1
    this.init()
    callback()
  }

  init () {
    Hero.init()
    lazyload.init()
    Header.init()
    // CtaMail.init()
    // LinesDetail.init()
    // AnimesUp.init()
  }

  unmout () {
    Hero.unmount()
    lazyload.remove()
    Header.unmount()
    // CtaMail.unmount()
    // LinesDetail.unmount()
    // AnimesUp.unmount()
  }
}

SingleProject.pname = 'SingleProject'

export default SingleProject
